import React from 'react';
import {SchemaContextProvider} from '../../components/schema/context/SchemaContext';
import Search from "./Search";
import ContentBlocker from "../../components/context/ContentBlocker";

/**
 * A page which wraps the search component providing schema context.
 */
class SearchPage extends React.Component {

  render() {
    return (
      <div className="SearchPage">
        <h1>Search</h1>
        <ContentBlocker checkReadPermission={true}>
          <SchemaContextProvider loadGraphQlSchema={true}>
            <Search/>
          </SchemaContextProvider>
        </ContentBlocker>
      </div>
    );
  }
}

export default SearchPage;
